// src/components/Header.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export default function Header({ user, setUser }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      if (setUser) setUser(null);
      navigate("/");
    } catch (err) {
      alert("Logout failed. Please try again.");
    }
  };

  if (!user) return null; // Only show header when logged in

  return (
    <header style={{
      width: "100%",
      background: "transparent",
      border: "none",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      minHeight: 0, // No forced height
      padding: 0,   // No padding
      margin: 0
    }}>
      <button
        onClick={handleLogout}
        style={{
          background: "#FFD166",
          border: "none",
          borderRadius: 16,
          padding: "8px 20px",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: "1em",
          margin: "12px 24px 0 0"
        }}
      >
        🚪 Log Out
      </button>
    </header>
  );
}
